 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLE from '@/components/title'
 import MAINTOC from '@/components/maintoc'
 import V11COVER from '@/components/v1/1cover'
 import V12TITLE_PAGE from '@/components/v1/2title_page'
 import V13TOC from '@/components/v1/3TOC'
 import V14CHAP1 from '@/components/v1/4chap1'
 import V15CHAP2 from '@/components/v1/5chap2'
 import V16CHAP3 from '@/components/v1/6chap3'
 import V17CHAP4 from '@/components/v1/7chap4'
 import V18CHAP5 from '@/components/v1/8chap5'
 import V19CHAP6 from '@/components/v1/9chap6'
 import V110CHAP7 from '@/components/v1/10chap7'
 import V111CHAP8 from '@/components/v1/11chap8'
 import V112CHAP9 from '@/components/v1/12chap9'
 import V113CHAP10 from '@/components/v1/13chap10'
 import V114CHAP11 from '@/components/v1/14chap11'
 import V115CHAP12 from '@/components/v1/15chap12'
 import V116CHAP13 from '@/components/v1/16chap13'
 import V117CHAP14 from '@/components/v1/17chap14'
 import V118CHAP15 from '@/components/v1/18chap15'
 import V119CHAP16 from '@/components/v1/19chap16'
 import V120CHAP17 from '@/components/v1/20chap17'
 import V21COVER from '@/components/v2/1cover'
 import V22TITLE_PAGE from '@/components/v2/2title_page'
 import V23CHAP1 from '@/components/v2/3chap1'
 import V24CHAP2 from '@/components/v2/4chap2'
 import V25CHAP3 from '@/components/v2/5chap3'
 import V26CHAP4 from '@/components/v2/6chap4'
 import V27CHAP5 from '@/components/v2/7chap5'
 import V28CHAP6 from '@/components/v2/8chap6'
 import V29CHAP7 from '@/components/v2/9chap7'
 import V210CHAP8 from '@/components/v2/10chap8'
 import V211CHAP9 from '@/components/v2/11chap9'
 import V212CHAP10 from '@/components/v2/12chap10'
 import V213CHAP11 from '@/components/v2/13chap11'
 import V214CHAP12 from '@/components/v2/14chap12'
 import V215CHAP13 from '@/components/v2/15chap13'
 import V216CHAP14 from '@/components/v2/16chap14'
 import V217CHAP15 from '@/components/v2/17chap15'
 import V218CHAP16 from '@/components/v2/18chap16'
 import V219CHAP17 from '@/components/v2/19chap17'
 import V220CHAP18 from '@/components/v2/20chap18'
 import V221CHAP19 from '@/components/v2/21chap19'
 import V222CHAP20 from '@/components/v2/22chap20'
 import V223CHAP21 from '@/components/v2/23chap21'
 import V224CHAP22 from '@/components/v2/24chap22'
 import V225CHAP23 from '@/components/v2/25chap23'
 import V226CHAP24 from '@/components/v2/26chap24'
 import V227CHAP25 from '@/components/v2/27chap25'
 import V3COVER from '@/components/v3/cover'
 import V3TITLE from '@/components/v3/title'
 import V3CHAPTER01 from '@/components/v3/chapter01'
 import V3CHAPTER02 from '@/components/v3/chapter02'
 import V3CHAPTER03 from '@/components/v3/chapter03'
 import V3CHAPTER04 from '@/components/v3/chapter04'
 import V3CHAPTER05 from '@/components/v3/chapter05'
 import V3CHAPTER06 from '@/components/v3/chapter06'
 import V3CHAPTER07 from '@/components/v3/chapter07'
 import V3CHAPTER08 from '@/components/v3/chapter08'
 import V3CHAPTER09 from '@/components/v3/chapter09'
 import V3CHAPTER10 from '@/components/v3/chapter10'
 import V3CHAPTER11 from '@/components/v3/chapter11'
 import V3CHAPTER12 from '@/components/v3/chapter12'
 import V4COVER from '@/components/v4/cover'
 import V4UNTITLED1 from '@/components/v4/Untitled1'
 import V4UNTITLED11 from '@/components/v4/Untitled11'
 import V4UNTITLED13 from '@/components/v4/Untitled13'
 import V4UNTITLED15 from '@/components/v4/Untitled15'
 import V4UNTITLED17 from '@/components/v4/Untitled17'
 import V4UNTITLED18 from '@/components/v4/Untitled18'
 import V4UNTITLED19 from '@/components/v4/Untitled19'
 import V4UNTITLED111 from '@/components/v4/Untitled111'
 import V4UNTITLED113 from '@/components/v4/Untitled113'
 import V4UNTITLED115 from '@/components/v4/Untitled115'
 import V4UNTITLED116 from '@/components/v4/Untitled116'
 import V4UNTITLED118 from '@/components/v4/Untitled118'
 import V4UNTITLED120 from '@/components/v4/Untitled120'
 import V4UNTITLED122 from '@/components/v4/Untitled122'
 import V4UNTITLED124 from '@/components/v4/Untitled124'
 import V4UNTITLED126 from '@/components/v4/Untitled126'
 import V4UNTITLED128 from '@/components/v4/Untitled128'
 import V4UNTITLED130 from '@/components/v4/Untitled130'
 import V4UNTITLED131 from '@/components/v4/Untitled131'
 import V4UNTITLED133 from '@/components/v4/Untitled133'
 import V4UNTITLED135 from '@/components/v4/Untitled135'
 import V4UNTITLED137 from '@/components/v4/Untitled137'
 import V4UNTITLED139 from '@/components/v4/Untitled139'
 import V4UNTITLED141 from '@/components/v4/Untitled141'
 import V4UNTITLED143 from '@/components/v4/Untitled143'
 import V4UNTITLED144 from '@/components/v4/Untitled144'
 import V4UNTITLED145 from '@/components/v4/Untitled145'
 import V4UNTITLED147 from '@/components/v4/Untitled147'
 import V4UNTITLED149 from '@/components/v4/Untitled149'
 import V4UNTITLED150 from '@/components/v4/Untitled150'
 import V4UNTITLED152 from '@/components/v4/Untitled152'
 import V4UNTITLED154 from '@/components/v4/Untitled154'
 import V4UNTITLED156 from '@/components/v4/Untitled156'
 import V4UNTITLED158 from '@/components/v4/Untitled158'
 import V4UNTITLED160 from '@/components/v4/Untitled160'
 import V4UNTITLED162 from '@/components/v4/Untitled162'
 import V4UNTITLED163 from '@/components/v4/Untitled163'
 import V4UNTITLED165 from '@/components/v4/Untitled165'
 import V4UNTITLED166 from '@/components/v4/Untitled166'
 import V4UNTITLED168 from '@/components/v4/Untitled168'
 import V4UNTITLED170 from '@/components/v4/Untitled170'
 import V4UNTITLED172 from '@/components/v4/Untitled172'
 import V4UNTITLED174 from '@/components/v4/Untitled174'
 import V4UNTITLED176 from '@/components/v4/Untitled176'
 import V4UNTITLED178 from '@/components/v4/Untitled178'
 import V4UNTITLED180 from '@/components/v4/Untitled180'
 import V4UNTITLED182 from '@/components/v4/Untitled182'
 import V4UNTITLED184 from '@/components/v4/Untitled184'
 import V4UNTITLED186 from '@/components/v4/Untitled186'
 import V4UNTITLED188 from '@/components/v4/Untitled188'
 import V4UNTITLED190 from '@/components/v4/Untitled190'
 import V4UNTITLED192 from '@/components/v4/Untitled192'
 import V4UNTITLED194 from '@/components/v4/Untitled194'
 import V4UNTITLED196 from '@/components/v4/Untitled196'
 import V4UNTITLED198 from '@/components/v4/Untitled198'
 import V4UNTITLED1100 from '@/components/v4/Untitled1100'
 import V4UNTITLED1102 from '@/components/v4/Untitled1102'
 import V4UNTITLED1104 from '@/components/v4/Untitled1104'
 import V4UNTITLED1106 from '@/components/v4/Untitled1106'
 import V4UNTITLED1108 from '@/components/v4/Untitled1108'
 import V4UNTITLED1110 from '@/components/v4/Untitled1110'
 import V4UNTITLED1112 from '@/components/v4/Untitled1112'
 import V4UNTITLED1114 from '@/components/v4/Untitled1114'
 import V4UNTITLED1116 from '@/components/v4/Untitled1116'
 import COPYRIGHT from '@/components/copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/maintoc",
 			"name" : "maintoc",
 			"component" : MAINTOC
 		},
 		{
 			"path" : "/v1/1cover",
 			"name" : "v1/1cover",
 			"component" : V11COVER
 		},
 		{
 			"path" : "/v1/2title_page",
 			"name" : "v1/2title_page",
 			"component" : V12TITLE_PAGE
 		},
 		{
 			"path" : "/v1/3TOC",
 			"name" : "v1/3TOC",
 			"component" : V13TOC
 		},
 		{
 			"path" : "/v1/4chap1",
 			"name" : "v1/4chap1",
 			"component" : V14CHAP1
 		},
 		{
 			"path" : "/v1/5chap2",
 			"name" : "v1/5chap2",
 			"component" : V15CHAP2
 		},
 		{
 			"path" : "/v1/6chap3",
 			"name" : "v1/6chap3",
 			"component" : V16CHAP3
 		},
 		{
 			"path" : "/v1/7chap4",
 			"name" : "v1/7chap4",
 			"component" : V17CHAP4
 		},
 		{
 			"path" : "/v1/8chap5",
 			"name" : "v1/8chap5",
 			"component" : V18CHAP5
 		},
 		{
 			"path" : "/v1/9chap6",
 			"name" : "v1/9chap6",
 			"component" : V19CHAP6
 		},
 		{
 			"path" : "/v1/10chap7",
 			"name" : "v1/10chap7",
 			"component" : V110CHAP7
 		},
 		{
 			"path" : "/v1/11chap8",
 			"name" : "v1/11chap8",
 			"component" : V111CHAP8
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js